import { render, staticRenderFns } from "./viewExibirRemessa.vue?vue&type=template&id=304e99e2"
import script from "./viewExibirRemessa.vue?vue&type=script&lang=ts"
export * from "./viewExibirRemessa.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports